import { DateTime } from "luxon";
import moment from "moment";

export function constructDiffString({ days }, before) {
  const today = DateTime.local().toLocaleString({ day: "numeric" });
  const before_date = before.setLocale("en").toFormat("d");
  if (today === before_date) {
    return before.setLocale("en").toLocaleString(DateTime.TIME_SIMPLE);
  }
  if (today - before_date === 1) {
    return `Yesterday, ${before
      .setLocale("en")
      .toLocaleString(DateTime.TIME_SIMPLE)}`;
  }
  return before.setLocale("en").toLocaleString(DateTime.DATETIME_MED);
}

export function analyzeDateUTC(fromdateUTC) {
  const now = DateTime.local();
  const before = DateTime.fromISO(fromdateUTC);
  const diff = now.diff(before, ["days"]);
  return constructDiffString(diff, before);
}



export const setDimensions = (field, value) => {
  localStorage.setItem(field, value);
};

export const parseISO = (isoDate, dateFormat) => {
  if (isoDate) {
    let x = Date.parse(isoDate);
    let date = new Date(x);
    return moment(date.toUTCString()).format(dateFormat);
  } else {
    return "-";
  }
};